import type { RootBlockModel } from '@blocksuite/affine-model';
import { WidgetComponent } from '@blocksuite/block-std';
import type { PageRootBlockComponent } from '@blocksuite/blocks';
import { css, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map.js';

export const PIQUE_VIEWPORT_OVERLAY_WIDGET = 'pique-viewport-overlay-widget';

@customElement(PIQUE_VIEWPORT_OVERLAY_WIDGET)
export class PiqueViewportOverlayWidget extends WidgetComponent<
  RootBlockModel,
  PageRootBlockComponent
> {
  static override styles = css`
    .pique-viewport-overlay-widget {
      position: absolute;
      top: 0;
      left: 0;
      background: transparent;
      pointer-events: none;
      z-index: calc(var(--affine-z-index-popover) - 1);
    }

    .pique-viewport-overlay-widget.lock {
      pointer-events: auto;
    }

  `;

  override connectedCallback() {
    super.connectedCallback();
    this.handleEvent(
      'dragStart',
      () => {
        return this._lockViewport;
      },
      { global: true }
    );
    this.handleEvent(
      'pointerDown',
      () => {
        return this._lockViewport;
      },
      { global: true }
    );
    this.handleEvent(
      'click',
      () => {
        return this._lockViewport;
      },
      { global: true }
    );
  }

  /**
   * Lock the viewport
   */
  lock() {
    this._lockViewport = true;
  }

  override render() {
    const classes = classMap({
      'pique-viewport-overlay-widget': true,
      lock: this._lockViewport,
    });

    const style = styleMap({
      width: `${this._lockViewport ? '100vw' : '0'}`,
      height: `${this._lockViewport ? '100%' : '0'}`,
    });

    return html`<div class=${classes} style=${style}></div>`;
  }

  toggleLock() {
    this._lockViewport = !this._lockViewport;
  }

  /**
   * Unlock the viewport
   */
  unlock() {
    this._lockViewport = false;
  }


  @state()
  private accessor _lockViewport = false;
}

declare global {
  interface HTMLElementTagNameMap {
    [PIQUE_VIEWPORT_OVERLAY_WIDGET]: PiqueViewportOverlayWidget;
  }
}
